import { withParams } from 'vuelidate';
export default withParams({ type: 'notStartingWithNumber' }, (value) => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	if (isNaN(parseFloat(value[0])) && !isFinite(value[0])) {
		return true;
	}
	return false;
});
